<mat-form-field
  [appearance]="appearance"
  class="w-full lla-input"
  [ngClass]="{
    'lla-input-smaller': size === 'smaller',
    'lla-input-small': size === 'small',
    'lla-input-default': size === 'default',
    'lla-input-textarea': type === 'textarea',
    'lla-login-input': loginInput,
    'lla-white-input': whiteMode
  }"
>
  @if (label) {
    <mat-label
      class="text-txt-secondary tracking-normal text-sm"
      [ngClass]="{
        'text-error': isFormControlInvalid()
      }"
    >
      <span class="inline-block lowercase first-letter:uppercase">{{ label }}</span>
    </mat-label>
  }
  @if (prefix) {
    <span matPrefix>{{ prefix }} &nbsp;</span>
  }

  @switch (type) {
    @case ('select') {
      <ng-container *ngTemplateOutlet="selectInputTemplate"></ng-container>
    }
    @case ('date') {
      <ng-container *ngTemplateOutlet="datePickerTemplate"></ng-container>
    }
    @case ('google-places') {
      <ng-container *ngTemplateOutlet="googlePlacesInputTemplate"></ng-container>
    }
    @case ('textarea') {
      <ng-container *ngTemplateOutlet="textAreaTemplate"></ng-container>
    }
    @default {
      <ng-container *ngTemplateOutlet="normalInputTemplate"></ng-container>
    }
  }

  @if (loading) {
    <mat-progress-spinner matSuffix [diameter]="16" mode="indeterminate"> </mat-progress-spinner>
  }
  @if (!disabled && !loading && icon && type !== 'password') {
    <ng-container matSuffix>
      @if (clearable && formControl.value && formControl.value !== '') {
        <svg-icon
          key="close-circle"
          class="cursor-pointer text-sm!"
          [color]="clearIconColor"
          [fontSize]="clearIconSize"
          (click)="formControl.reset()"
        ></svg-icon>
      } @else {
        <svg-icon
          [key]="icon"
          [color]="iconColor"
          [fontSize]="iconSize"
          (click)="iconClicked.emit($event)"
        ></svg-icon>
      }
    </ng-container>
  }
  @if (!loading && type === 'password') {
    <svg-icon
      matSuffix
      key="eye-light"
      [color]="iconColor"
      [fontSize]="iconSize"
      (click)="showPassword = !showPassword"
    ></svg-icon>
  }

  @if (showErrorMessage && isFormControlInvalid()) {
    <mat-error class="text-sm text-error tracking-normal mt-[3px]">
      {{ handleErrorMessage() }}
    </mat-error>
  }

  <ng-template #normalInputTemplate ngProjectAs="[matInput]">
    <input
      [id]="normalInputId"
      [mask]="useCurrencyMask() ? currencyMaskPattern() : mask"
      [suffix]="useCurrencyMask() ? currencyMaskSuffix() : maskSuffix"
      [prefix]="useCurrencyMask() ? currencyMaskPrefix() : ''"
      [thousandSeparator]="useCurrencyMask() ? ',' : ''"
      [allowNegativeNumbers]="useCurrencyMask() && currencyMaskAllowNegative()"
      matInput
      [type]="showPassword ? 'text' : type"
      [formControl]="formControl"
      [llaAutofocus]="autoFocus"
      [errorStateMatcher]="customErrorMatcher ? customErrorMatcher : errorMatcher"
      autocomplete="on"
      (blur)="inputFocusOut.emit()"
      (focus)="inputFocus.emit()"
      (wheel)="type === 'number' && $any($event.target).blur()"
      [placeholder]="placeholder"
      [readonly]="readonly"
      [style.text-align]="useCurrencyMask() ? currencyMaskAlign() : rightAlign ? 'right' : 'left'"
      [attr.inputmode]="inputmode"
      [attr.maxlength]="maxLength ?? null"
    />
  </ng-template>

  <ng-template #textAreaTemplate ngProjectAs="[matInput]">
    <textarea
      #textareaElement
      [mask]="mask"
      matInput
      [formControl]="formControl"
      [llaAutofocus]="autoFocus"
      [errorStateMatcher]="customErrorMatcher ? customErrorMatcher : errorMatcher"
      autocomplete="on"
      cdkTextareaAutosize
      [cdkAutosizeMinRows]="minTextAreaRows"
      [cdkAutosizeMaxRows]="maxTextAreaRows"
      [placeholder]="placeholder"
      [attr.maxlength]="maxLength ?? null"
      (input)="onTextareaInput()"
    ></textarea>
  </ng-template>

  <ng-template #googlePlacesInputTemplate ngProjectAs="[matInput]">
    <input
      matInput
      type="text"
      [formControl]="formControl"
      [llaAutofocus]="autoFocus"
      [errorStateMatcher]="customErrorMatcher ? customErrorMatcher : errorMatcher"
      id="google-places-input"
      [placeholder]="placeholder"
    />
  </ng-template>

  <ng-template #datePickerTemplate ngProjectAs="[matDatepicker]">
    <input
      matInput
      [matDatepicker]="picker"
      [formControl]="formControl"
      [max]="maxDate"
      [min]="minDate"
      (focus)="picker.open()"
      (click)="picker.open()"
      [placeholder]="placeholder"
      readonly
    />
    <mat-datepicker #picker [yPosition]="'below'"></mat-datepicker>
  </ng-template>

  <ng-template #selectInputTemplate ngProjectAs="mat-select">
    <mat-select
      [formControl]="formControl"
      disableOptionCentering
      panelClass="lla-select-panel {{ extraSelectPanelClass }}"
      [placeholder]="placeholder"
    >
      @for (item of items; track item) {
        <mat-option [value]="item.value" [disabled]="item.disabled">
          {{ item.label }}
        </mat-option>
      }
    </mat-select>
  </ng-template>
</mat-form-field>
